import type { Observer } from '@naturehouse/nh-essentials/lib/architecture/ObserverPattern';
import scrollToTarget from '@naturehouse/nh-essentials/lib/dom/scrollToTarget';
import PaginationFilter from './store/PaginationFilter';

export class ScrollToTopHouseSearch implements Observer {
    readonly #mainElement: HTMLElement;

    readonly #listView: HTMLElement;

    constructor(
        mainElement: HTMLElement,
        listView: HTMLElement,
        paginationFilter: PaginationFilter
    ) {
        this.#mainElement = mainElement;
        this.#listView = listView;
        paginationFilter.attach(this);
    }

    update(): void {
        if (!this.#listView.hasAttribute('hidden')) {
            scrollToTarget(this.#mainElement, 16, true);
        }
    }
}

export default new ScrollToTopHouseSearch(
    document.querySelector('#content') as HTMLElement,
    document.querySelector('[data-role="list-view"]') as HTMLElement,
    PaginationFilter.getInstance()
);
